

































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as analysesService from "@/services/analyses/index";
import { Analysis } from "@/api/analyses/types";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import AnalysisDelete from "@/components/analyses-delete/AnalysisDelete.vue";
import CropDrawer from "@/components/maps/CropDrawer.vue";
import * as resultsService from "@/services/results";
import * as cropApi from "@/api/crops";
import Loading from "@/components/loading/Loading.vue";
import * as notificationService from "@/services/notification/index";
import i18n from "@/i18n";


@Component({
  name: "CropUpdate",
  components: {
    AnalysisDelete, AgroIcons, CropDrawer, Loading
  },
})
export default class Analyses extends Vue {
  @Prop(String) public analysisUuid?: string;
  @Prop(String) public farmAnalysisUuid?: string;
  @Prop(Number) public year?: number;
  
  public result: any = null;
  private results: any[] = [];
  private url: string = '';
  private loading = false;
  
  async created() {
    await analysesService.getByUuid(this.analysisUuid!!);
    await this.loadResult();
  }
  
  public get analysis(): Analysis {
    return this.$store.state.analyses.analysesContext;
  }
  
  private async updatePolygns(data: any) {
    if (data.allYears) {
      for (const farmAnalysis of this.analysis.farmAnalyses) {
        await this.overridePolygons(data.polygons, farmAnalysis.analysisYear);
      }
    } else {
      await this.overridePolygons(data.polygons, this.year!!);
    }
  }
  
  public mountBackLink() {
    return { 
      name: this.analysis.analysisType === 'ANALITICA' ? 'analyses': 'monitoring', 
      params: { 
        uuid: this.analysis.uuid 
      } 
    }
  } 
  
  private async overridePolygons(polygons: any, year: number) {
    this.loading = true;
    if (polygons.length > 0) {
      await cropApi.override(this.analysisUuid!!, polygons, year);
    }
    await analysesService.updateAnalysis(this.analysisUuid!!, year);
    this.loading = false;
    notificationService.addSuccessNotification(
      i18n.t("notifications.success.analysis-update") as string
    );
  }

  private async loadResult() {
        const results = await resultsService.getFarmAnalysisResultList(this.farmAnalysisUuid!!, this.analysis.harvestSeason);
        this.result = results.find((result) => result.cropType === this.analysis.cropType) ?? results[0];
        this.results = results;
      this.url = this.result && this.result.s3GeoJsonUrl ? this.result.s3GeoJsonUrl : '';
  }

  get farmRegion() {
    if (this.analysis) {
      return [this.analysis.city, this.analysis.microRegion, this.analysis.state]
        .filter((v) => !!v)
        .join(" / ");
    }
    return "";
  }
}
